module.exports = __webpack_public_path__ + "static/media/Attachment 6 - TERMS-Definitions  Interpretaions.ec0cbc8d.pdf";